import { useIsPreview } from '@dreamstack/artemis'
import { useRouterLocalized } from '@dreamstack/i18n'
import type { FunctionComponent } from 'react'

export const ExitPreview: FunctionComponent<
  React.PropsWithChildren<{}>
> = () => {
  const isPreview = useIsPreview()
  const { asPathLocalized } = useRouterLocalized()
  return (
    <>
      {isPreview && (
        <a
          href={`/api/preview-exit?url=${asPathLocalized}`}
          className="w-full fixed text-center font-semibold p-1 z-50 opacity-80 text-white text-xl top-0 bg-accentroError-full"
        >
          Preview Modus aktiv - Klicken zum Beenden
        </a>
      )}
    </>
  )
}
